import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import Gnavbar from "../components/Gnavbar";
import BottomNavbar from "../components/BottomNavbar";
import SearchByMobile from "../components/SearchByMobile";

const SearchByMobilePage: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const stateMobile = (location.state as { mobile?: string } | null)?.mobile;
  const queryMobile = searchParams.get("m");
  const initialMobile = stateMobile || queryMobile || "";

  return (
    <div className="min-h-screen bg-gray-50 pb-28 md:pb-0">
      <Gnavbar />
      <div className="max-w-7xl mx-auto pt-6 pb-32 md:pb-24 px-2">
        <div className="px-2">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
            This profile already added by other bureaus
          </h1>
          <p className="text-sm text-gray-600 mt-2">
            Search by mobile number to see existing profiles.
          </p>
        </div>

        <div className="mt-6">
          <SearchByMobile
            initialMobile={initialMobile}
            autoSearch={!!initialMobile}
          />
        </div>
      </div>
      <BottomNavbar />
    </div>
  );
};

export default SearchByMobilePage;
